import isMergeableObject from 'is-mergeable-object'

import { ObjectId } from '@/utils/objectid'

const transformValue = (value: any): any => {
    // -- transformers

    if (value instanceof Date) {
        return { $date: value.toISOString() }
    }

    if (value instanceof ObjectId) {
        return { $oid: value.toString() }
    }

    // -- end transformers

    if (Array.isArray(value)) {
        return value.map((val) => transformValue(val))
    }

    if (isMergeableObject(value)) {
        return Object.keys(value).reduce(
            (res, key) => ({
                ...res,
                [key]: transformValue(value[key]),
            }),
            {} as const
        )
    }

    return value
}

export const serialize = (value: any) => {
    if (value === undefined) {
        return undefined
    }

    return JSON.stringify(transformValue(value))
}
